"use client"

import { MotionConfig } from "framer-motion"

/**
 * Client boundary so the server-rendered start page can opt every framer-motion
 * animation into the OS "reduce motion" preference.
 */
export function ReducedMotionProvider({ children }: { children: React.ReactNode }) {
  return <MotionConfig reducedMotion="user">{children}</MotionConfig>
}
